<template>
  <div class="culture">
    <AdenTitle class="mb-[52px]" :titles="['丰富文娱，诠释地道人文']"></AdenTitle>
    <div class="banner">
      <ul>
        <li>
          <div class="home__partner">
            <div class="">
              <ul class="home__partner-cruise-company">
                <div class="item__wrapper" v-for="(item, index) in list" :key="index">
                  <li class="home__partner-cruise-item" :class="{
                    'is-active': index == activeIndex
                  }" @mouseenter="handleHover(index, 1)">
                    <div class="cover" :style="{ backgroundImage: `url(${item.logo})` }">
                      <div class="cover__content">
                        <h6 class="cover-title">{{  item.name  }}</h6>
                        <p class="cover-desc line-clamp-1" v-html="item.desc" v-show="index == activeIndex"></p>
                      </div>
                    </div>
                    <!-- <div class="slider__opend" v-else :style="{ backgroundImage: `url(${item.logo})` }">
                      <div class="cover__content">
                        <h6 class="slider__opend__title">{{  item.name  }}</h6>
                        <p class="slider__opend__desc">{{  item.desc  }}</p>
                      </div>
                    </div> -->
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </li>
        <li>
          <div class="home__partner home__partner2">
            <div class="">
              <ul class="home__partner-cruise-company">
                <div class="item__wrapper" v-for="(item, index) in list2" :key="index">
                  <li class="home__partner-cruise-item" :class="{
                    'is-active': index == activeIndex2
                  }" @mouseenter="handleHover(index, 2)">

                    <div class="cover" :style="{ backgroundImage: `url(${item.logo})` }">
                      <div class="cover__content">
                        <h6 class="cover-title">{{  item.name  }}</h6>
                        <p class="cover-desc line-clamp-1" v-html="item.desc" v-show="index == activeIndex2"></p>
                      </div>
                    </div>

                    <!-- <div class="slider__opend" v-else :style="{ backgroundImage: `url(${item.logo})` }">
                      <div class="cover__content">
                        <h6 class="slider__opend__title">{{  item.name  }}</h6>
                        <p class="slider__opend__desc">{{  item.desc  }}</p>
                      </div>
                    </div> -->
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import AdenTitle from "@/views/topic/202208/aden/components/aden-title.vue";


export default defineComponent({
  name: "CultureEntertainment",
  components: {
    AdenTitle
  },
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_1.png"),
          name: "中央泳池",
          desc: "风雨无阻，随时尽兴",
          to: "/resource/product/list/cruise?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
          custom_to: "/customer/list?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_2.png"),
          name: "无边泳池",
          desc: "享受大海上的极致浪漫",
          to: "/resource/product/list/cruise?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
          custom_to: "/customer/list?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_3.png"),
          name: "健身房",
          desc: "激发您的肺活力",
          to: "/resource/product/list/vacation?keywords=松赞旅行",
          custom_to: "/customer/list?keyword=松赞旅行",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_4.png"),
          name: "海上图书馆",
          desc: "馆藏丰富的知识海洋",
          to: "/resource/product/list/vacation?keywords=车",
          custom_to: "/customer/list?keyword=车",
        },
      ],
      list2: [
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_5.png"),
          name: "水疗中心",
          desc: "体验不一样的北欧传统浴",
          to: "/resource/product/list/cruise?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
          custom_to: "/customer/list?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_6.png"),
          name: "品牌秀",
          desc: "与知名演艺集团联袂打造",
          to: "/resource/product/list/cruise?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
          custom_to: "/customer/list?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_7.png"),
          name: "人文演讲",
          desc: "题材有趣的精彩演说",
          to: "/resource/product/list/vacation?keywords=松赞旅行",
          custom_to: "/customer/list?keyword=松赞旅行",
        },
        {
          logo: require("@/views/topic/202208/aden/imgs/culture_8.png"),
          name: "现场音乐",
          desc: "为每一次营造美好氛围",
          to: "/resource/product/list/vacation?keywords=车",
          custom_to: "/customer/list?keyword=车",
        },
      ],
      activeIndex2: 1,
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
  },
  methods: {
    handleHover(index, type) { // type 1 | 2
      if (type == 1) {
        this.activeIndex = index;
      } else {
        this.activeIndex2 = index;
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base/_mixins";
@import "@/assets/scss/base/_var";
.culture {
  padding-top: 50px;
}
.home__partner {
  width: 1099px;
  margin: 0 auto;
}
.home__partner-cruise-company {
  @include clearfix;
}
.home__partner-cruise-item {
  float: left;
  width: 183px;
  height: 490px;
  background: #fff;
  margin-left: 18px;
  transition: all $primary-transition;
  overflow: hidden;
  text-align: center;
}
.home__partner-cruise-item:first-child {
  margin: 0;
}
.home__partner-cruise-item .cover {
  width: 100%;
  height: 490px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
  position: relative;
}
.home__partner-cruise-item .cover::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.home__partner-cruise-item .cover-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 2px;
  position: relative;
}
.home__partner-cruise-item .cover-desc {
  position: relative;
  font-size: 12px;
  font-weight: 600;
  padding-left: 2px;
}
.home__partner-cruise-item.is-active {
  width: 550px;
  height: 490px;
}
.home__partner-cruise-item.is-active .cover {
  background-position: center !important;
}
.cover__content {
  height: 210px;
  padding: 20px;
  text-align: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.74) 0%, rgba(0, 0, 0, 0) 100%);
}
.slider__opend {
  width: 550px;
  height: 490px;
  position: relative;
  background-position: center;
  background-size: cover;
  color: #fff;
}
.slider__opend__title {
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 24px;
  line-height: 1;
  margin-bottom: 12px;
  position: relative;
}
.slider__opend__title::after {
  content: "";
  transform: translateX(-50%);
  --tw-border-opacity: 1;
  border-color: rgba(198, 161, 74, var(--tw-border-opacity));
  border-width: 1px;
  position: absolute;
  bottom: 0px;
  left: 50%;
  width: 67px;
}
.slider__opend__desc {
  position: relative;
  font-size: 16px;
  font-weight: 600;
}
.home__partner .item__wrapper:nth-child(3) .cover {
  background-position-x: -136px;
}
.home__partner .item__wrapper:nth-child(4) .cover {
  background-position-x: -60px;
}
.home__partner2 .item__wrapper:nth-child(1) .cover {
  background-position-x: 0;
}
.home__partner2 .item__wrapper:nth-child(3) .cover {
  background-position-x: -295px;
}
.home__partner2 .item__wrapper:nth-child(4) .cover {
  background-position-x: -310px;
}
</style>
